/*!
 * © 2024. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For more information visit: https://egtuniverse.com/legal
 *
 * Created for Universe App Tools.
 *
 * Created by Justin K Kazmierczak.
 */
var _ = require("../../../uam/module.js")(module.exports, {
    namespace: "email.header",
    title: "Email Header",
    description: "Logo and app name header row for platform emails. Centered, max-width 480px.",
    supportServer: true,
    control: false,
    foruseIn: ["email"],
    fields: {}
});

var $ = require("../../../uam/scafolding.js");

exports.render = async function (options) {
    var { html } = await exports.renderEmail(options);
    return [{
        n: "ua.element.serverNotSupported",
        inner: {
            n: "json",
            type: "ua/interface",
            by: "email.header",
            i: JSON.stringify({
                n: "html",
                html: `<div style="max-width:480px;margin:0 auto;font-family:Arial,Helvetica,sans-serif;">${html}</div>`
            })
        }
    }];
};

exports.renderEmail = async function (options) {
    var cfg = $.config;
    var appUrl   = (cfg.my && cfg.my.app && cfg.my.app.url)  ? cfg.my.app.url.replace(/\/$/, "")  : "";
    var appName  = (cfg.my && cfg.my.app && cfg.my.app.name) ? cfg.my.app.name : "The Universe";
    var primary  = (cfg.my && cfg.my.app && cfg.my.app.colors && cfg.my.app.colors.primary) || "#C48D2F";
    var logoUrl  = appUrl + "/logo.png";

    var html = `<tr>
  <td align="center" style="padding:30px 20px 20px 20px;">
    <a href="${appUrl}" style="text-decoration:none;display:inline-block;">
      <img src="${logoUrl}" alt="${appName}" width="60" height="60"
           style="display:block;border:0;width:60px;height:60px;border-radius:8px;" />
    </a>
    <div style="margin-top:10px;font-family:Arial,Helvetica,sans-serif;font-size:18px;font-weight:bold;color:${primary};">
      ${appName}
    </div>
  </td>
</tr>`;

    var text = `${appName}\n${appUrl}\n`;

    return { html, text };
};
